import React from 'react'

import LogoStartupCraftGlyph from 'Assets/Svg/logoStartupCraft.svg'
import LogoStartupCraftAddonGlyph from 'Assets/Svg/logoStartupCraftAddon.svg'

import { Container } from './styles'

type Props = {
  withAddon?: boolean
  height?: number
}

function StartupCraftLogo({ withAddon, height = 44 }: Props) {
  return (
    <Container height={height} width={withAddon ? 'auto' : height}>
      {LogoStartupCraftGlyph()}

      {withAddon && LogoStartupCraftAddonGlyph()}
    </Container>
  )
}

export default StartupCraftLogo
